module.exports = __webpack_public_path__ + "media/about/PXL_20240411_145324437-ebaeee1d.jpg";